import { useBbContentPresenter } from '@Components/BigBrowse/bb2/BbContentPresenter';
import { useMiniMapWrapperStyle } from '@Map/MiniMap2/useWrapperStyles';
import OwnableTheme from '@Theme';
import { Entypo } from '@expo/vector-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import styled from 'styled-components/native';

import { NAV_BUTTON_SIZE } from './BBToolbarConstants';

const BBToolbar = () => {
  const { buttonsViews = [] } = useBbContentPresenter();
  const { width: mapWidth } = useMiniMapWrapperStyle();
  const isUltraSmall = mapWidth <= 105;

  const width = isUltraSmall ? mapWidth : NAV_BUTTON_SIZE.width;
  const bottomPadding = isUltraSmall ? 0 : 33;
  const iconSize = isUltraSmall ? 11 : 18;

  return (
    <StyledToolbarWrapper navButtonHeight={NAV_BUTTON_SIZE.height}>
      {buttonsViews.map((buttonView, index) => {
        const backgroundColor = buttonView.darkMode ? 'black' : 'white';
        const color = buttonView.darkMode ? 'white' : 'black';
        return (
          <Pressable onPress={buttonView.onClick} key={buttonView.key}>
            <Shadow
              style={{
                minHeight: NAV_BUTTON_SIZE.height,
                width,
                backgroundColor,
                bottom: bottomPadding + index * (NAV_BUTTON_SIZE.height + 13),
                paddingHorizontal: isUltraSmall ? 7 : 14,
              }}
            >
              <View style={styles.contentWrapper}>
                <Entypo
                  name='chevron-thin-left'
                  size={iconSize}
                  color={color}
                />
                <Text
                  style={[
                    styles.text,
                    { color, marginLeft: isUltraSmall ? 6 : 10 },
                  ]}
                  numberOfLines={2}
                >
                  {buttonView.title}
                </Text>
              </View>
            </Shadow>
          </Pressable>
        );
      })}
    </StyledToolbarWrapper>
  );
};

export default observer(BBToolbar);

const StyledToolbarWrapper = styled.View<{
  navButtonHeight: number;
}>`
  position: absolute;
  justify-content: center;
  align-items: flex-start;
  left: 20px;
  bottom: ${({ navButtonHeight }) => 73 + navButtonHeight}px;
`;

const Shadow = styled.View`
  position: absolute;
  box-shadow: 0 0 25px ${OwnableTheme.colors.modalShadow};
  background-color: black;
  justify-content: center;
  align-items: flex-start;
  border-radius: 15px;
  padding-left: 14px;
  padding-right: 14px;
`;

const styles = StyleSheet.create({
  text: {
    color: 'white',
    fontFamily: OwnableTheme.fonts.gilroy.regular,
    fontSize: 10,
    letterSpacing: (10 * 3) / 100,
    marginLeft: 10,
  },
  contentWrapper: { flexDirection: 'row', alignItems: 'center', width: '100%' },
});
